import { pickText, useTourState } from "@heroncendre/player";
import { accueil } from "./choix.js";
import { useRetourAccueil } from "./useRetourAccueil.js";
import { POLICE_UI_SPLASH, boutonLangue, traitLangue } from "./splashStyles.js";

/**
 * ============================================================================
 *  BoutonAccueil.tsx — Revenir à l'accueil, en haut à gauche
 * ----------------------------------------------------------------------------
 *  Il prolongeait la barre des langues ; il a pris le coin haut gauche, la
 *  place qu'on cherche d'instinct pour « revenir », et laisse le coin droit aux
 *  seules langues. Même dessin qu'elles (capitales espacées, ombre portée sur
 *  le panorama) : l'en-tête reste une seule famille de boutons.
 *
 *  Le libellé et son titre viennent de `accueil.json` : rien en dur ici.
 * ==========================================================================*/

export function BoutonAccueil({ onAccueil }: { onAccueil: () => void }) {
  const language = useTourState((state) => state.context.language);
  const retour = useRetourAccueil(onAccueil);

  return (
    <button
      type="button"
      title={pickText(accueil.retourTitre, language)}
      onClick={retour}
      style={{
        ...boutonLangue(false),
        fontFamily: POLICE_UI_SPLASH,
        textShadow: "0 0 3px rgba(0,0,0,.85), 0 1px 8px rgba(0,0,0,.7)",
        pointerEvents: "auto",
      }}
    >
      {(pickText(accueil.retour, language) ?? "").toUpperCase()}
      <span aria-hidden style={traitLangue(false)} />
    </button>
  );
}
